import { useState } from "react";
import { useSelector } from "react-redux";
export const useUser = () => {
  const user = useSelector((state) => state.userData.User.user);
  const fullUser = useSelector((state) => state.userData.User);
  return [user, fullUser];
};
